import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { MaintenanceView } from "../features/maintenance/index.ts";

export const Maintenance: FC = () => (
  <PageContainer>
    <MaintenanceView />
  </PageContainer>
);
